import { BackgroundIcon1 } from "../../../assets/svg";
import Image_16 from "../../../assets/16.jpeg";
import Image_5 from "../../../assets/5.jpeg";
import Image_9 from "../../../assets/9.jpeg";
import Image_4 from "../../../assets/4.jpeg";

const OurProjects = () => {
  return (
    <div className="relative ">
      <BackgroundIcon1 position="top-[50%] right-[5%]" />
      <BackgroundIcon1 position="top-[10%] left-[5%]" />
      <div className="flex flex-col justify-center items-center mt-12 px-4 md:px-20">
        <h1 className="text-[30px] md:text-[60px] text-center">
          Unsere Projekte
        </h1>
        <div className="lg:h-[70vh] w-full flex flex-col lg:flex-row gap-2 my-12">
          <img
            src={Image_16}
            className="z-10 w-full lg:w-1/3 h-full object-cover"
          />
          <div className="flex flex-col w-full h-full gap-2">
            <div className="flex flex-col lg:flex-row h-1/2  w-full gap-2">
              <img
                src={Image_5}
                className="z-10 w-full lg:w-1/2 h-full object-cover"
              />
              <img src={Image_9} className="z-10 w-full h-full object-cover" />
            </div>
            <img src={Image_4} className="z-10 w-full h-1/2 object-cover" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurProjects;
